import { ApiProperty } from "@nestjs/swagger";
import { IsOptional } from "class-validator";

export class unitIdRequest{
    @ApiProperty()
    unitId:number
    @ApiProperty()
    locationId?:number
}
export class FgIdRequest{
    @ApiProperty()
    fgDamageId:number

    @ApiProperty()
    updatedUser: string;

    @ApiProperty()
    @IsOptional()
    versionFlag: number;

    @ApiProperty()
    isActive: boolean;
}